import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
import { DxBaseUiOptions } from "../../../../dx-page-markup/domain/ui-options/dx-base-ui-options";
/**
 * Опции бокового меню навигатора.
 * @publicApi
 */
let DxSideNavigationMenuOptions = class DxSideNavigationMenuOptions extends DxBaseUiOptions {
    /**
     * Опции бокового меню навигатора.
     * @publicApi
     */
    constructor() {
        super(...arguments);
        this._enableMinification = true;
        this._isMinifiedByDefault = false;
    }
    get enableMinification() {
        return this._enableMinification;
    }
    set enableMinification(value) {
        this._enableMinification = value;
    }
    get isMinifiedByDefault() {
        return this._isMinifiedByDefault;
    }
    set isMinifiedByDefault(value) {
        this._isMinifiedByDefault = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "enableMinification", constructor: Boolean, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxSideNavigationMenuOptions.prototype, "_enableMinification", void 0);
tslib_1.__decorate([
    jsonMember({ name: "isMinifiedByDefault", constructor: Boolean, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxSideNavigationMenuOptions.prototype, "_isMinifiedByDefault", void 0);
DxSideNavigationMenuOptions = tslib_1.__decorate([
    jsonObject
], DxSideNavigationMenuOptions);
export { DxSideNavigationMenuOptions };
